import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/envelopes`, {params: {...filters}})
  },

  show(id) {
    return Http.get(`/envelopes/${id}`);
  },
  
  confirm_envelope(id, user_id) {
    return Http.put(`/envelopes/confirm_envelope/${id}`, {params : { user_id } } );
  },

  create(envelope){
    return Http.post(`/envelopes`, {envelope: {...envelope}})
  },

  update(envelope){
    return Http.put(`/envelopes/${envelope.id}`, {
      envelope: {...envelope},
    });
  },
  receive_envelope(envelope_id){
    return Http.put(`/envelopes/${envelope_id}`, {
      envelope: {
        id: envelope_id,
        was_received: true
      },
    });
  },
  updateWithFormData(envelope){
    return Http.put(`/envelopes/${envelope.get('envelope[id]')}`, envelope);
  },
  
  delete(id){
    return Http.delete(`/envelopes/${id}`)
  },

}
